
export const lerp = (currentValue: number, targetValue: number, ease = 0.1) => {
  return currentValue + (targetValue - currentValue) * ease
}

export const wait = (ms = 0) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}
